import MultistepForm from './multistep_form';

const init = () => {
  const builderForms = document.querySelectorAll(
    '.FormBuilder form[data-multistep]'
  );
  builderForms.forEach((formElem) => {
    new MultistepForm(formElem); // eslint-disable-line no-new
  });
};

window.addEventListener('DOMContentLoaded', init);
